// extracted by mini-css-extract-plugin
module.exports = {"SubscriptionPlan":"SubscriptionPlan_SubscriptionPlan__tuZdf"};